/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetHerdQueryResponse, GetHerdPathParams, GetHerd400, GetHerd401, GetHerd403, GetHerd404, GetHerd409, GetHerd500 } from "../../types/livestockController/GetHerd.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetHerdUrl(organizationId: GetHerdPathParams["organizationId"], herdId: GetHerdPathParams["herdId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock/herds/${herdId}` as const }
  return res
}

/**
 * @summary Get livestock herd by ID
 * {@link /api/organizations/:organizationId/livestock/herds/:herdId}
 */
export async function getHerd(organizationId: GetHerdPathParams["organizationId"], herdId: GetHerdPathParams["herdId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetHerdQueryResponse, ResponseErrorConfig<GetHerd400 | GetHerd401 | GetHerd403 | GetHerd404 | GetHerd409 | GetHerd500>, unknown>({ method : "GET", url : getGetHerdUrl(organizationId, herdId).url.toString(), ... requestConfig })
  return res.data
}